import { RouterConfig } from './utils/RouterConfig';

function App() {
  return (
      <RouterConfig />
  );
}

export default App;
